<template>
  <div class="dataList">
    <Row class="bottomCal" type="flex" justify="start">
      <Col span="24" class="colCall">
        <div class="card">
          <Card class="top-card">
            <Form
              ref="infoForm"
              :model="infoForm"
              :rules="formValidate"
              :label-width="80"
              label-position="left"
              class="nodeForm"
            >
              <FormItem label="URL：" prop="Url">
                <Input v-model="infoForm.Url" placeholder="请求地址" disabled />
              </FormItem>
              <FormItem label="Header：" prop="Header">
                <Input
                  v-model="infoForm.Header"
                  placeholder="Content-Type"
                  disabled
                />
              </FormItem>
            </Form>
            <div>
              <p>参数：</p>
              <!-- <div class="fields" v-for="(item, index) in fieldsList">
                <Input v-model="infoForm[item.columnName]">
                  <template #prepend>
                    <span>{{ item.columnName }}</span>
                  </template>
                </Input>
              </div> -->
              <div
                class="fields"
                v-for="(item, index) in fieldsList"
                :key="index"
              >
                <Row style="margin-top: 10px" :gutter="16">
                  <Col span="5">
                    <Input v-model="item.columnName" disabled></Input>
                  </Col>
                  <Col span="5">
                    <Select
                      v-model="item.operator"
                      placeholder="运算符"
                      clearable
                      transfer
                      disabled
                    >
                      <Option
                        v-for="(option, opIndex) in operatorList"
                        :key="opIndex"
                        :value="option.value"
                        >{{ option.name }}</Option
                      >
                    </Select>
                  </Col>
                  <Col span="5">
                    <!-- <Select
                          v-model="item.value"
                          filterable
                          allow-create
                          placeholder="请输入值"
                          @on-create="handleCreate1($event, index)"
                        >
                          <Option
                            v-for="(v, vindex) in item.valuesList"
                            :key="vindex"
                            :value="v.value ? v.value : v.groupcount"
                            >{{ v.name ? v.name : v.groupcount }}</Option
                          >
                        </Select> -->
                    <Input
                      v-model="item.value"
                      filterable
                      placeholder="请输入值"
                    ></Input>
                  </Col>
                  <!-- <Col span="5">
                    <Select v-model="item.logic" placeholder="逻辑" transfer>
                      <Option value=" And ">且</Option>
                      <Option value=" Or ">或者</Option>
                    </Select>
                  </Col> -->
                </Row>
              </div>
            </div>
            <div class="btn-box">
              <Button type="primary" @click="sendAjax" class="btnSmall"
                >发送请求</Button
              >
              <Button
                class="btnSmall"
                type="primary"
                @click="handleSubmitForProperty"
                >清空</Button
              >
            </div>
          </Card>
          <Card>
            <p>请求结果 :</p>
            <div class="table-box">
              <Table
                border
                ref="resTable"
                :columns="resColumns"
                :data="resTablesList"
                max-height="240"
              >
              </Table>
            </div>
          </Card>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import detail from "./detail.js";
export default detail;
</script>

<style lang="less" scoped>
.dataList {
  width: 100%;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .bottomCal {
    width: 100%;
    height: 100%;
    overflow: auto;
    .colCall {
      height: 100%;
      .card {
        height: 100%;
      }
    }
  }
  .top-card {
    margin-bottom: 10px;
  }
  .table-box {
    margin-top: 10px;
  }
  .fields {
    padding: 5px 0 5px 80px;
  }
  .btn-box {
    text-align: right;
  }
  .btnSmall {
    margin: 10px 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/leftmenu/layers/detail.vue